import React from 'react';
import TreeTable from './TreeTable';


import Button from '@material-ui/core/Button';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Snackbar from '@material-ui/core/Snackbar';


const COLUMNS = ["Field", "Value", "Type"];

function prepareDocument(document, label = "Document") {
	if(document.bsonType) {
		switch(document.bsonType) {
			case "DATE_TIME":
				return (
					{
						data: {
							label: label,
							value: new Date(document.value).toLocaleString(),
							type: document.bsonType
						},
						children: []
					}
				);
			default:
				return (
					{
						data: {
							label: label,
							value: document.value,
							type: document.bsonType,
						},
						children: []
					}
				);
		}
	}
	else {
		const children = Object.entries(document).map(field =>
			prepareDocument(field[1], field[0])
		);
		return (
			{
				data: {
					label: label,
					value: "",
					type: ""
				},
				children: children
			}
		);
	}
}

class MongoDbResponse extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			copiedSuccessMessageShown: false
		}
		this.handleCopyJson = this.handleCopyJson.bind(this);
		this.handleCopiedMessageClose = this.handleCopiedMessageClose.bind(this);
	}
	handleCopyJson(event) {
		event.stopPropagation();
		navigator.clipboard.writeText(this.props.value.asJson).then(
			() => {
				this.setState({copiedSuccessMessageShown: true});
			},
			() => {
				// Failed to copy to clipboard. Show an alert.
				alert(this.props.value.asJson);
			}
		);
	}


	handleCopiedMessageClose() {
		this.setState({copiedSuccessMessageShown: false});
	}
	render() {
		const documents = this.props.value.documents.map(prepareDocument);

		const lengthText = this.props.value.documents.length + " document" + (this.props.length >= 2 ? "s" : "");

		return (
			<>
				<Accordion>
					<AccordionSummary expandIcon={<ExpandMoreIcon/>}>
						<div class={"accordionSummary"}>
							<div className="tableName">{this.props.name + " (" + lengthText + ")"}</div>
							<div className="jsonButton">
								<Button variant={"contained"} onClick={this.handleCopyJson}>Copy as JSON</Button>
							</div>
						</div>
					</AccordionSummary>
					<AccordionDetails>
						<TreeTable columns={COLUMNS} documents={documents}/>
					</AccordionDetails>
				</Accordion>
				<Snackbar open={this.state.copiedSuccessMessageShown} onClose={this.handleCopiedMessageClose} autoHideDuration={5000} message="Copied to clipboard"/>
			</>
		);
	}
}

export default MongoDbResponse;